import { render, staticRenderFns } from "./SettingsField.vue?vue&type=template&id=0a5f94c5&"
import script from "./SettingsField.vue?vue&type=script&lang=js&"
export * from "./SettingsField.vue?vue&type=script&lang=js&"
import style0 from "./SettingsField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports